import { mutator } from 'satcheljs';
import getStore from '../store/store';
import selectReminderDefaultTimeOption from '../../actions/selectReminderDefaultTimeOption';
import CalendarReminder from 'owa-service/lib/contract/CalendarReminder';

/**
 * Called when there is a change in the default reminder dropdown
 */

export default mutator(selectReminderDefaultTimeOption, actionMessage => {
    let defaultReminderTime: CalendarReminder = actionMessage.defaultReminderTime;
    getStore().defaultReminderTime = defaultReminderTime;
});
